module.exports = __webpack_public_path__ + "static/media/rain.980290b7.png";